/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Speed_TitleInputs */

const en_onboarding_speed_title = /** @type {(inputs: Onboarding_Speed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed Preferences`)
};

const es_onboarding_speed_title = /** @type {(inputs: Onboarding_Speed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencias de velocidad`)
};

/**
* | output |
* | --- |
* | "Speed Preferences" |
*
* @param {Onboarding_Speed_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_speed_title = /** @type {((inputs?: Onboarding_Speed_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Speed_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_speed_title(inputs)
	return en_onboarding_speed_title(inputs)
});